import styled from "@emotion/styled";

export const InnerWrapper = styled.div(({theme}) => ({
  display: "flex",
  flexDirection: "column",
  gridColumn: "1/-1",
  paddingBlock: theme?.breakpoints?.isMobile ? 30 : 40,
}));

export const CardsWrapper = styled.div(({theme}) => ({
  display: "grid",
  gridGap: 20,
  gridTemplateColumns: theme?.breakpoints?.isMobile
    ? "repeat(1, 1fr)"
    : theme?.breakpoints?.md
      ? "repeat(2, 1fr)"
      : "repeat(4, 1fr)",
}));
